import { render, staticRenderFns } from "./MatchUp.vue?vue&type=template&id=90df9978&scoped=true&lang=pug&"
import script from "./MatchUp.vue?vue&type=script&lang=ts&"
export * from "./MatchUp.vue?vue&type=script&lang=ts&"
import style0 from "./MatchUp.vue?vue&type=style&index=0&id=90df9978&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90df9978",
  null
  
)

export default component.exports